import { render, staticRenderFns } from "./addXWXX.vue?vue&type=template&id=44c5e537&scoped=true&"
import script from "./addXWXX.vue?vue&type=script&lang=js&"
export * from "./addXWXX.vue?vue&type=script&lang=js&"
import style0 from "./addXWXX.vue?vue&type=style&index=0&id=44c5e537&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c5e537",
  null
  
)

export default component.exports